import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme?.createWaitList?.backgroundColor,
  },
  header: {
    backgroundColor: theme?.createWaitList?.headerBackgroundColor,
  },
  title: {
    fontWeight: 600,
    textAlign: 'center',
    color: theme?.createWaitList?.textColor,
    marginLeft: theme.spacing(2),
  },
  closeImg: {
    color: theme?.createWaitList?.closeIconColor,
  },
  input: {
    height: '40px',
    borderColor: theme?.createWaitList?.inputBorderColor,
    borderWidth: '1px',
    borderRadius: '2px',
    borderStyle: 'solid',
    fontSize: '14px',
    color: theme?.createWaitList?.inputTextColor,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    width: 'calc(100% - 16px)',
  },
  contryInput: {
    width: 'calc(100% - 4px)',
    height: '100%',
    marginBottom: 0,
},
  label: {
    color: theme?.createWaitList?.textColor,
    marginBottom: '10px',
  },
  textarea: {
    height: '9.6vh',
    borderColor: theme?.createWaitList?.inputBorderColor,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '2px',
    fontSize: '14px',
    color: theme?.createWaitList?.inputTextColor,
    marginBottom: '10px',
    padding: theme.spacing(1),
  },
  button: {
    backgroundColor: theme?.createWaitList?.primaryButtonBackgroundColor,
    color: theme?.createWaitList?.primaryButtonTextColor,
    marginBottom: theme.spacing(2),
  },
  secondaryButton: {
    backgroundColor: theme?.createWaitList?.secondaryButtonBackgroundColor,
    color: theme?.createWaitList?.secondaryButtonTextColor,
    borderColor: theme?.createWaitList?.secondaryButtonBorderColor,
  },
}));

export default useStyles;
